/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

// An action a page adds to a feed card by projecting it into the card's actions group
// (`<ut-community-feed-item><my-action feedItemAction /></ut-community-feed-item>`), e.g. the community
// profile's Pin. Provide this token from the action so the card can offer it in the ⋯ menu on phones,
// where the labelled buttons are hidden.
export abstract class FeedItemExtraAction {
  abstract readonly menuLabel: string;
  // Path data for a 24×24 viewBox `0 -960 960 960` icon (Material Symbols).
  abstract readonly menuIconPath: string;
  abstract trigger(): void;
}
